<app-loader [hidden]="(loaderService.isLoading$ | async) === false"></app-loader>

<noscript
  ><iframe
    [src]="dataLayerNoScriptSafeUrl"
    height="0"
    width="0"
    style="display: none; visibility: hidden"
  ></iframe
></noscript>

<ng-template cxOutletRef="cx-header"></ng-template>

<!-- Remove 'SiteLogin' and 'PreHeader' slots from all pages -->
<ng-template cxOutletRef="SiteLogin"></ng-template>
<ng-template cxOutletRef="PreHeader"></ng-template>

<app-haba-storefront
  [isCheckout]="isCheckout"
  [isOrderConfirmation]="isOrderConfirmation"
></app-haba-storefront>

<ng-template cxOutletRef="cx-footer"></ng-template>

<app-notification></app-notification>
